import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiInstagram, FiYoutube, FiFacebook, FiTwitter } from 'react-icons/fi';
import HeaderLogo from '../assets/Header_Transparent.png';

const services = [
    'Modular Kitchen', 'Wardrobes & Storage', 'TV Unit & Crockery Unit',
    'False Ceiling', 'Wall Paneling', 'Bathroom Design',
    'Pooja Unit', 'Kids Bedroom', 'Foyer Design',
];

export default function Footer() {
    const cities = [
        'Hyderabad', 'Nizamabad', 'Bangalore', 'Vizag',
        'Puttaparthi', 'Anantapur', 'Vijayawada', 'Rajahmundry'
    ];

    return (
        <footer className="bg-[#0D0D0D] text-gray-400">
            {/* Main Footer */}
            <div className="max-w-7xl mx-auto px-4 py-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                    {/* Brand */}
                    <div>
                        <div className="flex items-center gap-2 mb-5">
                            <img src={HeaderLogo} alt="BLiv Design Studio" className="h-10 w-auto" />
                        </div>
                        <p className="text-sm leading-relaxed mb-6">
                            Leading luxury interior designers. End-to-end interior solutions for homes and offices — from design to delivery.
                        </p>
                        <div className="space-y-2 text-sm">
                            <a href="tel:+919959365158" className="flex items-center gap-2 hover:text-[#2E63E8] transition-colors">
                                <FiPhone size={14} /> +91 9959365158
                            </a>
                            <a href="tel:+917330676456" className="flex items-center gap-2 hover:text-[#2E63E8] transition-colors">
                                <FiPhone size={14} /> +91 7330676456
                            </a>
                            <a href="mailto:Bhavana@blivdesigns.com" className="flex items-center gap-2 hover:text-[#2E63E8] transition-colors">
                                <FiMail size={14} /> Bhavana@blivdesigns.com
                            </a>
                            <p className="flex items-start gap-2">
                                <FiMapPin size={14} className="mt-0.5 flex-shrink-0" />
                                Plot No 761, CBI Colony , Jubliee Hills, Road No - 39, Hyderabad, Telangana - 500033
                            </p>
                        </div>
                        {/* Social */}
                        <div className="flex gap-3 mt-5">
                            {[FiInstagram, FiYoutube, FiFacebook, FiTwitter].map((Icon, i) => (
                                <a key={i} href="#" className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#2E63E8] hover:text-white transition-all">
                                    <Icon size={16} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 className="text-white font-bold text-base mb-5 pb-2 border-b border-gray-800">Our Services</h4>
                        <ul className="space-y-2">
                            {services.map((s, i) => (
                                <li key={i}>
                                    <a href="/services" className="text-sm hover:text-[#2E63E8] transition-colors flex items-center gap-2 group">
                                        <span className="w-1 h-1 bg-[#2E63E8] rounded-full group-hover:bg-[#2E63E8] transition-colors"></span>
                                        {s}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Cities */}
                    <div>
                        <h4 className="text-white font-bold text-base mb-5 pb-2 border-b border-gray-800">We Serve</h4>
                        <ul className="space-y-2">
                            {cities.map((c, i) => (
                                <li key={i}>
                                    <a href="/cities" className="text-sm hover:text-[#2E63E8] transition-colors flex items-center gap-2 group">
                                        <span className="w-1 h-1 bg-[#2E63E8] rounded-full group-hover:bg-[#2E63E8] transition-colors"></span>
                                        {c}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Quick Links + Form */}
                    <div>
                        <h4 className="text-white font-bold text-base mb-5 pb-2 border-b border-gray-800">Get Free Estimate</h4>
                        <form className="space-y-3" onSubmit={e => e.preventDefault()}>
                            <input type="text" placeholder="Your Name" className="w-full bg-white/5 border border-gray-700 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:border-[#2E63E8] focus:outline-none transition-colors" />
                            <input type="tel" placeholder="Phone Number" className="w-full bg-white/5 border border-gray-700 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:border-[#2E63E8] focus:outline-none transition-colors" />
                            <select className="w-full bg-white/5 border border-gray-700 rounded-lg px-4 py-3 text-sm text-gray-400 focus:border-[#2E63E8] focus:outline-none transition-colors">
                                <option value="">Select Service</option>
                                {services.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                            <button type="submit" className="btn-yellow w-full py-3 text-sm">
                                Get Free Estimate
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-800 py-5 px-4">
                <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-600">
                    <p>© {new Date().getFullYear()} BLiv Design Studio. All rights reserved.</p>
                    <p>
                        Designed and Developed by{' '}
                        <a href="https://www.vikrin.com/" target="_blank" rel="noopener noreferrer" className="text-[#2E63E8] hover:underline">
                            Vikrin Pvt Ltd
                        </a>
                    </p>
                    <div className="flex gap-4">
                        <a href="#" className="hover:text-gray-400 transition-colors">Privacy Policy</a>
                        <a href="#" className="hover:text-gray-400 transition-colors">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
